import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_USET_MY_COURSES_URL } from '@services/react-query/urls/user'
import { useQuery } from '@tanstack/react-query'
import { CourseVersion, CourseProgress } from '@type/course'
import Cookies from 'js-cookie'

const useGetMyCourses = (enabled = false, isAuthLoading = false) => {
  const token = Cookies.get(AUTH_TOKEN_KEY)

  const { ...data } = useQuery<{
    courses: CourseVersion[]
    progress: CourseProgress[]
  }>({
    queryKey: ['my-courses'],
    queryFn: () => FETCH_WITH_TOKEN(GET_USET_MY_COURSES_URL()),
    // Wait until auth has settled before firing: on a fresh load the token
    // cookie can still be the previous, expired Firebase ID token until
    // onAuthStateChanged refreshes it, which would otherwise cause a 401.
    enabled: enabled && !!token && !isAuthLoading,
    gcTime: 1000 * 60 * 10, // 10 minutes
  })

  return data
}

export default useGetMyCourses
